import type {Dayjs} from 'dayjs';
import {DatePicker, theme} from 'antd';
import dayjs from 'dayjs';
import React from 'react';

interface IProps {
  date?: Date | null;
  handleChange: any;
  label?: string;
  flex?: number;
  minDate?: any;
  position?: 'end' | 'start' | undefined;
  reset?: any;
  inline?: boolean;
  disabled?: boolean;
  showTime?: boolean;
}

// Note: unlike the MUI version (date-fns + localeMap[tenantConfig.locale]), this
// doesn't wire the tenant's locale into antd's date formatting yet — antd's locale
// system works differently (ConfigProvider `locale`, not a date-fns Locale object).
// Known gap, same one flagged when SearchMember's Date of Birth field moved to antd.
const CustomDatePicker: React.FC<IProps> = (props) => {
  const {
    date,
    handleChange,
    label,
    flex = 1,
    minDate = null,
    inline,
    disabled = false,
    showTime = false,
  } = props;
  const {token}: any = theme.useToken();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        flex,
        marginRight: inline ? 16 : undefined,
      }}>
      {label && (
        <span
          style={{
            fontSize: 17,
            fontWeight: 'bold',
            color: disabled ? token.colorTextDisabled : token.colorTextBase,
          }}>
          {label}
        </span>
      )}
      <DatePicker
        value={date ? dayjs(date) : null}
        disabled={disabled}
        showTime={showTime}
        allowClear
        maxDate={dayjs()}
        {...(minDate && {minDate: dayjs(minDate)})}
        // antd reports a dayjs value (or null on clear); bridge back to a native
        // Date so every existing handleChange/formik.setFieldValue caller is unchanged.
        onChange={(value: Dayjs | null) => handleChange(value ? value.toDate() : null)}
        style={{width: '100%'}}
      />
    </div>
  );
};

export default CustomDatePicker;
